const PERMISSION_SIDE_NAV_MAP = {
  'dashboard:global': null,
  'operaciones:tablero': { parent: 'operaciones', path: 'tablero' },
  'operaciones:inversionistas': { parent: 'operaciones', path: 'inversionistas' },
  'operaciones:pymes': { parent: 'operaciones', path: 'pymes' },
  'operaciones:honorarios': { parent: 'operaciones', path: 'honorarios' },
  'operaciones:cronograma': { parent: 'operaciones', path: 'cronograma' },
  'operaciones:cierre': { parent: 'operaciones', path: 'cierre' },
  'operaciones:archivos': { parent: 'operaciones', path: 'archivos' },
  'operaciones:comunicaciones': { parent: 'operaciones', path: 'comunicaciones' },
  'operaciones:estructuracion': { parent: 'operaciones', path: 'estructuracion' },
  'operaciones:llamado_capital': { parent: 'operaciones', path: 'llamadoCapital' },
  'operaciones:seguimiento': { parent: 'operaciones', path: 'seguimiento' },
  'operaciones:fiduciaria': { parent: 'operaciones', path: 'fiduciaria' },
  'operaciones:tipos_inversion': { parent: 'operaciones', path: 'tiposInversion' },
  'operaciones:configuracion': { parent: 'operaciones', path: 'configuracion' },
  'operaciones:alimentar': { parent: 'operaciones', path: 'alimentar' },
  'inversionista:dashboard': { parent: 'inversionista', path: 'dashboard' },
  'inversionista:oportunidades': { parent: 'inversionista', path: 'oportunidades' },
  'inversionista:mis_inversiones': { parent: 'inversionista', path: 'misInversiones' },
  'inversionista:historial': { parent: 'inversionista', path: 'historial' },
  'inversionista:estado_cuenta': { parent: 'inversionista', path: 'estadoCuenta' },
  'inversionista:archivos': { parent: 'inversionista', path: 'archivos' },
  'pyme:dashboard': { parent: 'pyme', path: 'dashboard' },
  'pyme:solicitar': { parent: 'pyme', path: 'solicitar' },
  'pyme:cotizador': { parent: 'pyme', path: 'cotizador' },
  'pyme:cronograma': { parent: 'pyme', path: 'cronograma' },
  'pyme:facturacion': { parent: 'pyme', path: 'facturacion' },
  'pyme:contrato': { parent: 'pyme', path: 'contrato' },
  'pyme:alertas': { parent: 'pyme', path: 'alertas' },
  'pyme:honorarios': { parent: 'pyme', path: 'honorarios' },
  'pyme:cierre': { parent: 'pyme', path: 'cierre' },
  'pyme:archivos': { parent: 'pyme', path: 'archivos' },
};

export const ALL_PERMISSIONS = [
  { key: 'dashboard:global', label: 'Dashboard Global', grupo: 'Dashboard' },
  { key: 'inversionistas:create', label: 'Crear perfiles de inversionista', grupo: 'Operaciones' },
  { key: 'inversionistas:update', label: 'Editar perfiles de inversionista', grupo: 'Operaciones' },
  {
    key: 'inversionistas:delete',
    label: 'Eliminar perfiles de inversionista',
    grupo: 'Operaciones',
  },
  { key: 'pymes:create', label: 'Crear perfiles de PYME', grupo: 'Operaciones' },
  { key: 'pymes:update', label: 'Editar perfiles de PYME', grupo: 'Operaciones' },
  {
    key: 'pymes:delete',
    label: 'Eliminar perfiles de PYME',
    grupo: 'Operaciones',
  },
  {
    key: 'usuarios:crear_cuenta',
    label: 'Crear cuentas (PYME / Inversionista)',
    grupo: 'Usuarios',
  },
  { key: 'usuarios:aprobar_pyme', label: 'Aprobar PYMEs pendientes', grupo: 'Usuarios' },
  { key: 'operaciones:tablero', label: 'Tablero', grupo: 'Operaciones' },
  { key: 'operaciones:inversionistas', label: 'Inversionistas', grupo: 'Operaciones' },
  { key: 'operaciones:pymes', label: 'PYMEs', grupo: 'Operaciones' },
  { key: 'operaciones:honorarios', label: 'Honorarios', grupo: 'Operaciones' },
  { key: 'operaciones:cronograma', label: 'Cronograma de Pagos', grupo: 'Operaciones' },
  { key: 'operaciones:cierre', label: 'Cierre de Operaciones', grupo: 'Operaciones' },
  { key: 'operaciones:archivos', label: 'Gestión de Archivos', grupo: 'Operaciones' },
  { key: 'operaciones:comunicaciones', label: 'Comunicaciones', grupo: 'Operaciones' },
  { key: 'operaciones:estructuracion', label: 'Revisión de Solicitudes', grupo: 'Operaciones' },
  { key: 'operaciones:llamado_capital', label: 'Llamado de Capital', grupo: 'Operaciones' },
  { key: 'operaciones:seguimiento', label: 'Seguimiento', grupo: 'Operaciones' },
  { key: 'operaciones:fiduciaria', label: 'Fiduciaria', grupo: 'Operaciones' },
  { key: 'operaciones:tipos_inversion', label: 'Tipos de Inversión', grupo: 'Operaciones' },
  { key: 'operaciones:configuracion', label: 'Configuración de Costos', grupo: 'Operaciones' },
  { key: 'firma:editar', label: 'Editar firma de correos', grupo: 'Operaciones' },
  { key: 'operaciones:alimentar', label: 'Alimentar al Sistema', grupo: 'Operaciones' },
  { key: 'inversionista:dashboard', label: 'Dashboard', grupo: 'Inversionista' },
  { key: 'inversionista:oportunidades', label: 'Oportunidades', grupo: 'Inversionista' },
  { key: 'inversionista:mis_inversiones', label: 'Mis Inversiones', grupo: 'Inversionista' },
  { key: 'inversionista:historial', label: 'Historial', grupo: 'Inversionista' },
  { key: 'inversionista:estado_cuenta', label: 'Estado de Cuenta', grupo: 'Inversionista' },
  { key: 'inversionista:archivos', label: 'Gestión de Archivos', grupo: 'Inversionista' },
  { key: 'pyme:dashboard', label: 'Dashboard', grupo: 'PYME' },
  { key: 'pyme:solicitar', label: 'Solicitar', grupo: 'PYME' },
  { key: 'pyme:cotizador', label: 'Cotizador', grupo: 'PYME' },
  { key: 'pyme:cronograma', label: 'Cronograma', grupo: 'PYME' },
  { key: 'pyme:facturacion', label: 'Facturación', grupo: 'PYME' },
  { key: 'pyme:contrato', label: 'Contrato', grupo: 'PYME' },
  { key: 'pyme:alertas', label: 'Alertas', grupo: 'PYME' },
  { key: 'pyme:honorarios', label: 'Honorarios', grupo: 'PYME' },
  { key: 'pyme:cierre', label: 'Cierre', grupo: 'PYME' },
  { key: 'pyme:archivos', label: 'Gestión de Archivos', grupo: 'PYME' },
  { key: 'users:list', label: 'Ver Usuarios', grupo: 'Admin' },
  { key: 'users:manage', label: 'Gestionar Usuarios', grupo: 'Admin' },
  { key: 'roles:assign', label: 'Asignar Roles', grupo: 'Admin' },
  { key: 'permissions:assign', label: 'Asignar Permisos', grupo: 'Admin' },
  { key: 'seace:view', label: 'SEACE', grupo: 'Legado' },
  { key: 'mivivienda:view', label: 'Fondo Mivivienda', grupo: 'Legado' },
];

export const canAccess = (user, permissionKey) => {
  if (!user) return false;
  return user.permissions && user.permissions.includes(permissionKey);
};

export const getSideNavPermissions = (permissions) => {
  const navGroups = {};
  permissions.forEach((perm) => {
    const map = PERMISSION_SIDE_NAV_MAP[perm];
    if (map && map.parent) {
      if (!navGroups[map.parent]) navGroups[map.parent] = [];
      navGroups[map.parent].push(map.path);
    }
  });
  return navGroups;
};
